import React from 'react';
import PropTypes from 'prop-types';

const SearchListItemLink = props => (
  <a className="afd-search-list__link" href={props.link} target="_blank">
    {props.children}
  </a>
);

SearchListItemLink.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.node,
};

SearchListItemLink.defaultProps = {
  children: null,
};

export default SearchListItemLink;
